import React from 'react';
import { connect } from 'react-redux';
import { deleteFile } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';

const actions = {
  closeModal,
  deleteFile,
};

function ModalDeleteFile({ data, deleteFile, closeModal }) {
  const auth = data?.auth;
  const history = data?.history;
  const file = data?.file;
  const filename = file?.filename;
  const rpp = data?.rpp;
  const screenWidth = useScreenWidth();

  function handleDelete() {
    deleteFile(auth, history, rpp, file);
    closeModal();
  }

  return (
    <Modal
      variant='danger'
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <p className='px-4 my-5 mx-1'>
        Apakah Anda yakin ingin menghapus file{' '}
        <span className='has-text-danger has-text-weight-semibold'>
          {filename}
        </span>?
      </p>
      <div className='flex justify-end align-center px-4 pt-2'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={handleDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteFile);
